import type { AiNoteCheckId } from './fhirNoteMapping';

/** Checks evaluated locally while the provider edits (PRD: while drafting). */
export const DRAFT_CHECK_IDS = ['required-fields', 'quotes-in-note'] as const satisfies readonly AiNoteCheckId[];

/** Checks produced by the post-save AI note check bot (PRD: on save). */
export const SERVER_CHECK_IDS = [
  'similarity-prior',
  'names-in-note',
  'quotes-in-note',
] as const satisfies readonly AiNoteCheckId[];

export const CHECK_LABELS: Record<AiNoteCheckId, string> = {
  'required-fields': 'Required fields',
  'similarity-prior': 'Similarity to prior note',
  'names-in-note': 'Names included in note',
  'quotes-in-note': 'Direct quotes in note',
};

/** Status-aware display labels for the flat quality checklist. */
export function getCheckDisplayLabel(
  id: string,
  status: 'passed' | 'flagged' | 'review_recommended',
  fallbackLabel?: string,
): string {
  if (id === 'quotes-in-note') {
    return status === 'passed' ? 'No direct quotes in note' : 'Direct quotes in note';
  }
  if (id in CHECK_LABELS) {
    return CHECK_LABELS[id as AiNoteCheckId];
  }
  return fallbackLabel ?? id;
}
